import {CommonModule} from '@angular/common';
import {Component, OnDestroy, ViewChild} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatSelectModule} from '@angular/material/select';
import {MatSort, MatSortModule} from '@angular/material/sort';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {
  CreerModifierGroupeDiffusionDialogueComponent
} from './creer-modifier-groupe-diffusion-dialogue/creer-modifier-groupe-diffusion-dialogue.component';
import {GroupeUsersService} from '../../../services/groupe-users/groupe-users.service';
import {merge, startWith, Subscription, tap} from 'rxjs';
import {Params} from '@angular/router';
import {Groupe} from '../../../models/groupes/Groupe';
import {GroupesService} from '../../../services/groupes/groupes.service';

@Component({
  selector: 'app-groupe-diffusion',
  standalone: true,
  imports: [MatTableModule, MatIconModule, MatSortModule, MatPaginatorModule, MatCardModule, MatDividerModule, MatSelectModule, MatDialogModule, CommonModule],
  templateUrl: './groupe-diffusion.component.html',
  styleUrl: './groupe-diffusion.component.scss'
})
export class GroupeDiffusionComponent implements OnDestroy {

  displayedColumns: string[] = ['titre', 'nmbr_utilisateurs', 'creation_datetime', 'actions'];
  dataSource = new MatTableDataSource<Groupe>();
  filterStatus = '';
  filterType = '';
  subscriptions: Subscription[] = [];

  @ViewChild(MatSort) sort?: MatSort;
  @ViewChild(MatPaginator) paginator?: MatPaginator;

  constructor(public dialog: MatDialog, private groupeUsersService: GroupeUsersService, private groupesService: GroupesService) {
  }

  ngAfterViewInit() {

    if (this.sort && this.paginator) {
      this.subscriptions.push(
        this.sort.sortChange.subscribe(() => (this.paginator!.pageIndex = 0))
      )

      this.subscriptions.push(
        merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          startWith(null),
          tap(() => this.loadGroupUsers())
        )
        .subscribe()
      )
    } else {
      this.loadGroupUsers();
    }
  }

  loadGroupUsers() {
    if (this.paginator && this.sort) {
      const params: Params = {
        page: this.paginator.pageIndex + 1,
        limit: this.paginator.pageSize
      };

      if (this.sort.active && this.sort.direction !== '') {
        params['orderBy'] = this.sort.active;
        params['direction'] = this.sort.direction;
      }

      this.subscriptions.push(
        this.groupesService.getGroupes(params).subscribe({
          next: (groups) => {
            console.log('groups', groups);
            const groupsWithUserCount = groups.data.map((group: Groupe) => ({
              ...group,
              nmbr_utilisateurs: group.groupeUsers ? group.groupeUsers.length : 0
            }));
            this.dataSource.data = groupsWithUserCount;
            this.paginator!.length = groups.total;

          },
          error: (error) => {
            console.error('Erreur lors de la récupération des groupes des utilisateurs', error);
          }
        })
      )
    }
  }

  openCreateDialog(): void {
    const dialogRef = this.dialog.open(CreerModifierGroupeDiffusionDialogueComponent, {
      width: '1200px',
      height: '500px'
    });
    dialogRef.afterClosed().subscribe(() => {
      this.loadGroupUsers();
    });
  }

  openEditDialog(groupe: Groupe): void {
    const dialogRef = this.dialog.open(CreerModifierGroupeDiffusionDialogueComponent, {
      width: '1200px',
      height: '500px',
      data: { groupe }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadGroupUsers();
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(x => x.unsubscribe());
  }
}
